import React, { useEffect, useState } from "react";
import { DivGeneral } from "../../screens/consultaBilletera";
import { Animated } from "react-animated-css";
import { DivRow } from "../../tools/identificadorQRCliente/PaginaSolicitudRetiro";
import NumberFormat from "react-number-format";
import walletImgMODO from "../../img/wallets/modo.png";
import ImgWallets from "../../img/wallets/wallet.png";
import styled from "styled-components";
import ButtonSalta from "./ButtonSalta";
import $ from "jquery";
import QRCode from "qrcode.react";
import EfectoCargando, { DivCargando } from "../../tools/EfectoCargando";
import { useHistory } from "react-router-dom";
import ButtonBlocked from "../ButtonBlocked/ButtonBlocked";
import { calculateDiffSecondsTime, segsToMinutes } from "../../tools/format";


const inputStyles = {
  border: "1px solid #D0D5DA",
  fontWeight: "bold",
  textAlign: "center",
  borderRadius: "10px",
  fontSize: "1.2rem",
  padding: "3px",
};

const inputProps = {
  type: "text",
  autoComplete: "off",
  maxLength: 13,
  isNumericString: true,
  decimalScale: 2,
  placeholder: "$ 0,00",
  prefix: "$ ",
  displayType: "input",
  thousandSeparator: ".",
  decimalSeparator: ",",
};

const PENDING = "PENDIENTE";
const PAID = "PAGADO";
const EXPIRED = "EXPIRADO";

const inactiveSessionError = [
  { error: "Su sesión ha cerrado por inactividad" },
];

const DepositMoneySalta = ({
  estadoPlataforma,
  montoConDecimales,
  setmontoConDecimales,
  propDeposito,
  formatearNumeroString,
  cumpleRequisito,
  mensajeErrorWS,
  lanzarModalCuil,
}) => {
  const isIOSSafari = (() => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    const isIOS = /iP(hone|od|ad)/i.test(ua);
    const isSafari = /Safari/i.test(ua) && !/Chrome/i.test(ua) && !/CriOS/i.test(ua);
    return isIOS && isSafari;
  })();

  const history = useHistory();
  const walletImages = require.context('../../img/wallets', true, /\.png$/);
  const [id, setId] = useState(null);
  const [brandId, setBrandId] = useState(null)
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [pendingOrder, setPendingOrder] = useState({ orderId: "", amount: 0, nombreMetodo: "" });
  const [qrCode, setQrCode] = useState("");
  const [loadingGenerateOrder, setLoadingGenerateOrder] = useState(false);
  const [loadingCancelOrder, setLoadingCancelOrder] = useState(false);
  const [loadingWallets, setLoadingWallets] = useState(false);
  const [orderStatus, setOrderStatus] = useState("");
  const [expirationTime, setExpirationTime] = useState(2) // En minutos 

  const [disableButton, setDisableButton] = useState(false)
  const [timeToWait, setTimeToWait] = useState()


  // const generalError = () => {
  //   mensajeErrorWS("Error", [
  //     { error: "Ocurrió un error, por favor intente de nuevo." },
  //   ]);
  // };

  const commonHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + estadoPlataforma.userToken,
  };

  useEffect(() => {
    estadoPlataforma.logueado && $("#idMontoSolicitudSalta").focus();
  }, []);

  useEffect(() => {
    if (wallets.length === 1 && wallets[0].nombre === "MODO") {
      setSelectedWallet(wallets[0]);
    }
  }, [wallets]);

  useEffect(() => {
    if (id) {
      getPaymentMethods(id);
    }
  }, [id])

  const getUserWalletData = () => {
    let closeSession = false;
    let url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_USER_WALLET_DATA;

    fetch(url, {
      method: "GET",
      headers: { ...commonHeaders },
    })
      .then((respPromise) => {
        if (respPromise.status == process.env.REACT_APP_CODIGO_CERRO_SESION) {
          closeSession = true;
        }
        return respPromise.json();
      })
      .then((json) => {
        if (closeSession) {
          mensajeErrorWS("Consulta de billetera", inactiveSessionError, true);
          return;
        }

        if (json) {
          setId(json)

          // generateQR(json); // generate the qr before generate de order to deposit, cuz it needs to be associated to the user
        } else {
          mensajeErrorWS("Error", [
            { error: "No se pudo obtener los datos de la billetera." },
          ]);
        }
      })
      .catch((error) => {
        mensajeErrorWS("Error", [
          { error: "Ocurrió un error, por favor intente de nuevo." },
        ]);
      });
  };

  const getPendingOrder = () => {
    let url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_GET_PENDING_DEPOSIT_ORDER;

    fetch(`${url}?nombreMetodo=${selectedWallet.nombre}`, {
      method: "GET",
      headers: { ...commonHeaders },
    })
      .then((respPromise) => {

        return respPromise.json();
      })
      .then((data) => {

        setPendingOrder({ orderId: data.ordenPendiente, amount: data.importe, nombreMetodo: data?.nombreMetodo ?? "" });
      })
      .catch((error) => { });
  };

  const getPaymentMethods = async (id) => {
    setLoadingWallets(true);
    let url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_GET_PAYMENT_METHODS;

    url = url.replace(":codOrg", process.env.REACT_APP_COD_ORGANIZACION)

    fetch(url, {
      method: "GET",
      headers: { ...commonHeaders },
    })
      .then((respPromise) => {
        return respPromise.json();
      })
      .then((data) => {
        data.map((wallet, keyWallet) => {
          wallet.id = id;
        })
        setWallets(data)
        setLoadingWallets(false);
      })
      .catch((error) => { });
  }

  const sendInfoPaydiss = async () => {
    window.openPaydiss('divPaydiss', {
      b: process.env.REACT_APP_COD_BRAND_PAYDISS,
      s: estadoPlataforma.userToken,
      p: 'web',
      e: process.env.REACT_APP_PDSS_MODE, // test || prod
      data_d: estadoPlataforma.cuil.split("-")[1] ?? "",
      data_n: estadoPlataforma.nombre ?? "",
      data_a: estadoPlataforma.apellido ?? "",
      data_id: id,
      data_e: estadoPlataforma.email ?? undefined,
      data_txid: estadoPlataforma.cuil.replaceAll("-", "") ?? "",
    });
  }

  useEffect(() => {
    if (estadoPlataforma.logueado) {
      if (selectedWallet) {

        switch (selectedWallet.nombre) {
          case "MODO":
            generateQR(id)
            getPendingOrder();
            break;
          default:
            sendInfoPaydiss();
            break;
        }
      }

      getUserWalletData();
    }
  }, [selectedWallet]);

  useEffect(() => {
    let interval = null;

    if (estadoPlataforma.logueado && pendingOrder.orderId) {
      interval = setInterval(() => {

        getDepositStatus(pendingOrder.orderId, selectedWallet.nombre);
      }, 1500);
    }
    return () => clearInterval(interval);
  }, [pendingOrder.orderId, estadoPlataforma.logueado]);

  useEffect(() => {
    const timeAnterior = JSON.parse(localStorage.getItem("expiracion"))
    const timeActual = Date.now();

    const diffSegundos = Math.floor((timeActual - timeAnterior) / 1000)
    const faltaEsperar = (expirationTime * 60) - diffSegundos;

    setTimeToWait(segsToMinutes(faltaEsperar))

    if (faltaEsperar <= 0) {
      localStorage.removeItem("expiracion");
      setDisableButton(false)
    } else {
      setDisableButton(true)
      setLoadingGenerateOrder(false)
    }
  }, [timeToWait])

  const handleGenerateDeposit = () => {
    let closeSession = false;
    let url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_GENERAR_ORDEN_CARGA;
    setLoadingGenerateOrder(true);

    if (estadoPlataforma.cuil === null) {
      lanzarModalCuil()
      setLoadingGenerateOrder(false)
      return
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + estadoPlataforma.userToken,
      },
      body: JSON.stringify({
        nombreMetodo: selectedWallet.nombre,
        identificacion: selectedWallet.id,
        importeCarga: montoConDecimales,
      }),
    })
      .then((res) => {
        setLoadingGenerateOrder(false);
        if (res.status == process.env.REACT_APP_CODIGO_CERRO_SESION)
          closeSession = true;

        return res.json();
      })
      .then((json) => {

        if (closeSession) {
          mensajeErrorWS("Generación de orden", inactiveSessionError, true);
          return;
        }

        if (json.ordenId) {
          window.generarEvento("pago_creado", "Generacion de Orden de Pago", {
            order_id: json.ordenId,
            monto: montoConDecimales,
            metodo_pago: selectedWallet.nombre,
          });
          setPendingOrder({
            orderId: json.ordenId,
            amount: montoConDecimales,
            nombreMetodo: selectedWallet.nombre,
          });
        } else {
          mensajeErrorWS("Error", [
            { error: json.error || "No se pudo generar la orden de depósito." },
          ]);

          if (json.codigo === 195) {
            const match = json.error.match(/(\d{2}):(\d{2})/);

            const expTime = parseInt(match[1], 10) + (parseInt(match[2], 10) / 60)


            setExpirationTime(expTime)
            setTimeToWait(segsToMinutes(expTime))
            localStorage.setItem("expiracion", Date.now());
            setDisableButton(true)
          }
        }
      })
      .catch((error) => {
        setLoadingGenerateOrder(false);
        mensajeErrorWS("Error", [
          { error: "Ocurrió un error, por favor intente de nuevo." },
        ]);



      });
  };

  const handleCancelDepositOrder = () => {
    let closeSession = false;
    let url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_USER_CANCEL_DEPOSIT_ORDER;
    setLoadingCancelOrder(true);

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + estadoPlataforma.userToken,
      },
      body: JSON.stringify({ orden: pendingOrder.orderId }),
    })
      .then((res) => {
        setLoadingCancelOrder(false);
        if (res.status == process.env.REACT_APP_CODIGO_CERRO_SESION)
          closeSession = true;

        return res.json();
      })
      .then((json) => {
        if (closeSession) {
          mensajeErrorWS("Cancelación de orden", inactiveSessionError, true);
          return;
        }

        if (json) {
          setmontoConDecimales(0)
          setPendingOrder({ orderId: "", amount: 0 });
          mensajeErrorWS("Cancelación exitosa", [
            { error: "Orden de depósito cancelada correctamente." },
          ]);
        } else {
          mensajeErrorWS("Error", [
            { error: "No se pudo cancelar la orden de depósito." },
          ]);
        }
      })
      .catch((error) => {
        setLoadingCancelOrder(false);
        mensajeErrorWS("Error", [
          { error: "Ocurrió un error, por favor intente de nuevo." },
        ]);
      });
  };

  const generateQR = (walletId) => {
    const url = process.env.REACT_APP_WS_GENERATE_QR_FOR_DEPOSIT;
    const orgCode = process.env.REACT_APP_COD_ORGANIZACION;

    fetch(`${url}?inst=${orgCode}&billeteraId=${walletId}`, {
      method: "GET",
      headers: { ...commonHeaders },
    })
      .then((respPromise) => {
        return respPromise.json();
      })
      .then((json) => {

        if (json.qr_data) {
          setQrCode(json.qr_data);
        } else {
          mensajeErrorWS(`Error: ${json?.error_code}`, [
            { error: json?.error_desc },
          ]);
        }
      })
      .catch((error) => mensajeErrorWS("Error", [
        { error: "Ocurrió un error, por favor intente de nuevo." },
      ]));
  };

  const getDepositStatus = (orderId, nameMethod) => {
    const url = process.env.REACT_APP_WS_GET_DEPOSIT_STATUS;

    fetch(`${url}?id_orden=${orderId}&nombreMetodo=${nameMethod}`, {
      method: "GET",
      headers: { ...commonHeaders },
    })
      .then((respPromise) => {
        return respPromise.json();
      })
      .then((json) => {
        setOrderStatus(json.status);
        if ([PAID, EXPIRED].includes(json.status)) {
          setPendingOrder({ orderId: "", amount: 0, nombreMetodo: "" });
        }
        if (json.status === PAID) {
          window.generarEvento("pago_resultado", "Resultado de Pago", {
            order_id: json.ordenId,
            monto: montoConDecimales,
            metodo_pago: nameMethod,
            estado_pago: "Pagado"
          });
          mensajeErrorWS("Depósito exitoso", [
            { error: "Tu saldo ha sido actualizado." },
          ]);
          window.refreshSaldo();
        }
      })
      .catch((error) => mensajeErrorWS("Error", [
        { error: "Ocurrió un error, por favor intente de nuevo." },
      ]));
  };

  if (!estadoPlataforma.logueado)
    return (
      <DivGeneral className="pageFlow" style={{ position: "relative" }}>
        <NotAllowedDiv onClick={() => $("#loginModal").modal("show")} />
        {/* template when no there is no session */}
        <DepositMoneySaltaTemplate
          propDeposito={propDeposito}
          formatearNumeroString={formatearNumeroString}
        />
      </DivGeneral>
    );


  return (
    <>
      <DivGeneral className="pageFlow" style={{ position: "relative" }}>
        {loadingWallets ? (
          <DivCargando className="container">
            <EfectoCargando />
          </DivCargando>
        ) : (
          <Animated
            animationIn="fadeIn"
            hidden={estadoPlataforma.estado !== "PLATAFORMA"}
          >
            {!pendingOrder.orderId && wallets.length > 0 && (
              <div className="container">
                {wallets.length > 0 && !selectedWallet && (
                  <>
                    <DivRow className="row justify-content-center">
                      <WalletContainer>
                        {wallets.map((wallet, keyWallet) => (
                          <NewDivWallet
                            key={keyWallet}
                            selected={selectedWallet === wallet.id}
                            onClick={() => setSelectedWallet(wallet)}
                            title={wallet.nombre}

                          >
                            <BackgroundWallet src={walletImages(`./${wallet.bg}.png`).default} alt={wallet.name} />
                            <NewImgWallet src={walletImages(`./${wallet.img}`).default} alt={wallet.name} />
                            <WalletSelect>Depositar</WalletSelect>
                          </NewDivWallet>
                        ))}
                      </WalletContainer>
                    </DivRow>
                  </>
                )}
                {selectedWallet && selectedWallet.nombre === "MODO" &&
                  <>
                    {/*<ButtonBackWallet onClick={() => setSelectedWallet(null)} type="button">← Volver</ButtonBackWallet>*/}
                    <DivRow className="row justify-content-center">

                      <WalletSelected className="align-items-center">
                        {(["53", "23"].includes(process.env.REACT_APP_COD_ORGANIZACION)) ? (
                          <DivWalletSAL selected={true} title={selectedWallet.nombre}>
                            <ImgWallet src={ImgWallets} alt="wallet image" />
                          </DivWalletSAL>
                        ) : (
                          <DivWallet selected={true} title={selectedWallet.nombre}>
                            <ImgWallet src={walletImages(`./${selectedWallet.img}`).default} alt={selectedWallet.nombre} />
                          </DivWallet>
                        )}
                        <div>
                          <h6>
                            Importe a <span className="m-bold">Ingresar</span>
                          </h6>
                          <NumberFormat
                            {...inputProps}
                            id="idMontoSolicitudSalta"
                            name="fMontoSolicitud"
                            style={inputStyles}
                            onValueChange={(values) => {
                              setmontoConDecimales(values.floatValue);
                            }}
                          />
                        </div>
                      </WalletSelected>
                    </DivRow>
                    {propDeposito !== undefined && (
                      <DivRow className="row justify-content-center">
                        <div
                          className="col-12"
                          style={
                            cumpleRequisito()
                              ? { fontSize: "12px" }
                              : { fontSize: "12px", color: "red" }
                          }
                        >
                          <h6>
                            Desde: ${" "}
                            {formatearNumeroString(
                              propDeposito.minTrans?.toString() ?? ""
                            )}{" "}
                            Hasta: ${" "}
                            {formatearNumeroString(
                              propDeposito.maxDia?.toString() ?? ""
                            )}
                          </h6>
                        </div>
                        <div
                          className="col-12"
                          style={
                            cumpleRequisito()
                              ? { fontSize: "12px" }
                              : { fontSize: "12px", color: "red" }
                          }
                        >
                          Múltiplo: $ {propDeposito.mulTrans}
                        </div>
                      </DivRow>
                    )}
                    <DivRow className="row justify-content-center">
                      <div className="col-10">
                        {wallets.length > 1 && (
                          <ButtonSalta
                            variant="danger"
                            id="botonVolver"
                            onClick={() => setSelectedWallet(null)}
                            className="mr-2"
                          >
                            ← Volver
                          </ButtonSalta>
                        )}
                        <ButtonSalta
                          variant="success"
                          disabled={
                            !cumpleRequisito(selectedWallet.nombre) ||
                            loadingGenerateOrder || disableButton
                          }
                          id="botonGenerarSolicitud"
                          onClick={handleGenerateDeposit}
                        >
                          {(!disableButton && loadingGenerateOrder) && (
                            <div className="animate-flicker">
                              <b>Cargando</b>
                            </div>
                          )}
                          {(disableButton && !loadingGenerateOrder) && <ButtonBlocked time={expirationTime} timeToWait={timeToWait} setTimeToWait={setTimeToWait} setDisableButton={setDisableButton} />}
                          {!disableButton && !loadingGenerateOrder && "Depositar"}
                        </ButtonSalta>
                      </div>
                    </DivRow>
                  </>
                }
              </div>
            )}

            {pendingOrder.orderId && qrCode && orderStatus === PENDING && (
              <div className="container">
                <DivRow className="row justify-content-center">
                  <Animated animationIn="zoomIn">
                    <div
                      style={{
                        fontSize: ".8rem",
                        margin: "0 0 10px 0",
                      }}
                    >
                      Escanea el código QR
                    </div>
                    <QRCode className="mb-1" value={qrCode} />
                    {pendingOrder.amount && (
                      <div className="m-bold">
                        <h6 className="mb-0">
                          $ {formatearNumeroString(pendingOrder.amount.toString())}
                        </h6>
                      </div>
                    )}
                  </Animated>
                </DivRow>
                <DivRow className="row justify-content-center">
                  <ButtonSalta
                    variant="danger"
                    type="button"
                    onClick={() => {
                      handleCancelDepositOrder();
                    }}
                    disabled={loadingCancelOrder}
                  >
                    {loadingCancelOrder ? (
                      <div className="animate-flicker">
                        <b>Cargando</b>
                      </div>
                    ) : (
                      "Cancelar"
                    )}
                  </ButtonSalta>
                </DivRow>
              </div>
            )}

          </Animated>
        )}
      </DivGeneral>
      {selectedWallet && selectedWallet.nombre === "PAYDISS" &&
        <PaydissOverlay
          id="modalPaydiss"
          aria-labelledby="modalPaydissLabel"
          aria-modal="true"
          role="dialog"
        >
          <PaydissDialog isIOSSafari={isIOSSafari}>
            <PaydissHeader className="bg-light text-dark mb-1 text-center">
              <h5 id="modalPaydissLabel" className="modal-title">Depositar</h5>
              <ButtonSalta
                variant="danger"
                id="botonGenerarSolicitud"
                onClick={() => setSelectedWallet(null)}
              >
                ← Volver
              </ButtonSalta>
            </PaydissHeader>
            <PaydissBody className="p-0">
              <div id="divPaydiss" style={{ width: "100%", height: "100%" }}></div>
            </PaydissBody>
            {process.env.REACT_APP_PDSS_TRANSFER_WARNING_MODAL && process.env.REACT_APP_PDSS_TRANSFER_WARNING_MODAL !== "" && (
              <div className="alert alert-warning mt-3 w-100 p-3 text-justify" role="alert" style={{ fontSize: "14px" }}>
                <Animated animationIn="bounceIn" animationOut="fadeOut" isVisible={true}>
                  <strong style={{ fontSize: "16px" }}>⚠️</strong> {process.env.REACT_APP_PDSS_TRANSFER_WARNING_MODAL}
                </Animated>
              </div>
            )}
          </PaydissDialog>
        </PaydissOverlay>
      }
    </>
  );
};

export default DepositMoneySalta;

const WalletContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
`;

const ButtonBackWallet = styled.button`
  background: none;
  border: none;
  outline: none;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 15px;

  &:hover{
    cursor: pointer;
    text-decoration: underline;
  }
`

const WalletSelected = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
`;

const DivColumn = styled.div`
  text-align: center;
  margin-top: 4vh;
  display: flex;
  flex-direction: column;
`

const DivWallet = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 100%;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease-in-out;
  padding: 3px;

  ${({ selected }) =>
    selected
      ? ` 
      border-color: ${process.env.REACT_APP_MANIFEST_COLOR};
      transform: scale(1.1);`
      : `&:hover {
        transform: scale(1.1);
        border-color: transparent;
      }`}
`;

const DivWalletSAL = styled.div`
  width: 85px;
  height: 85px;
  border-radius: 100%;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease-in-out;
  padding: 3px;
  @media (min-width: 768px) {
    margin-left: -120px;
  }

  ${({ selected }) =>
    selected
      ? ` 
      border-color: ${process.env.REACT_APP_MANIFEST_COLOR};
      transform: scale(1.1);`
      : `&:hover {
        transform: scale(1.1);
        border-color: transparent;
      }`}
`;

const NewDivWallet = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 15px auto;
  height: 100px;
  width: 320px;
  transition: 0.5s all;

  &:hover{
    cursor: pointer;
    transform: translateY(-5px);
  }
`
const BackgroundWallet = styled.img`
  position: absolute;
  z-index: 1;
  width: 100%;
  object-fit: contain;
`
const ImgWallet = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;ok, tengo la contestación por correo igual, ahora la subo al ticket
`;

const NewImgWallet = styled.img`
  height: 105px;
  width: 105px;
  object-fit: cover;
  position: absolute;
  z-index: 2;
  top: -20px;
  left: 30px;
`

const WalletSelect = styled.h2`
  font-family: "Inter", sans-serif;
  font-weight: 800;
  color: black !important;
  font-size: 23px;
  position:absolute;
  z-index: 2;
  right: 25px;
  top: 50%;
`

const NotAllowedDiv = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const PaydissOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(8, 8, 8, 0.9);
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
`;

const PaydissDialog = styled.div`
  background-color: #ffffff;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;

  @media (max-width: 576px) {
    max-width: 100%;
    border-radius: 0;
    height: ${({ isIOSSafari }) => (isIOSSafari ? "50vh" : "90vh")};
  }
`;

const PaydissHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
`;

const PaydissBody = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const DepositMoneySaltaTemplate = (props) => {
  const data = props?.propDeposito;
  const codOrg = process.env.REACT_APP_COD_ORGANIZACION;
  const showWalletSAL = ["53", "23"].includes(codOrg);
  return (
    <Animated animationIn="fadeIn">
      <div className="container">
        <DivRow className="row justify-content-center">
          <WalletSelected className="align-items-center">
            {showWalletSAL ? (
              <DivWalletSAL selected={true} title={"WALLET"}>
                <ImgWallet src={ImgWallets} alt={"wallet image"} />
              </DivWalletSAL>
            ) : (
              <DivWallet selected={true} title={"MODO"}>
                <ImgWallet src={walletImgMODO} alt={"modo image"} />
              </DivWallet>
            )}
            <div>
              <h6>
                Importe a <span className="">Ingresar</span>
              </h6>
              <NumberFormat {...inputProps} style={inputStyles} readOnly />
            </div>
          </WalletSelected>
        </DivRow>
        <DivRow className="row justify-content-center">
          <div className="col-12" style={{ fontSize: "12px" }}>
            <h6>
              Desde: ${" "}
              {props.formatearNumeroString(data?.minTrans?.toString() ?? "0")} Hasta:
              $ {props.formatearNumeroString(data?.maxDia?.toString() ?? "0")}
            </h6>
          </div>
          <div className="col-12" style={{ fontSize: "12px" }}>
            Múltiplo: $ {data?.mulTrans ?? "0"}
          </div>
        </DivRow>
        <DivRow className="row justify-content-center">
          <div className="col-12">
            <ButtonSalta variant="success">Ingresar</ButtonSalta>
          </div>
        </DivRow>
      </div>
    </Animated>
  );
};
